export const URl_PREFIX = '/account-lookup';
export const LOOKUP_PAGE_TITLE = 'Account Lookup';
export const IDENTITY_PAGE_TITLE = 'Records Search | Identity Info';
export const LOOKUP_PAGE_DESCRIPTION = 'cvs.com account lookup';
export const LEXIS_NEXIS_TITLE = 'Answer Questions';
export const MNO_ERROR_TITLE = 'mno error';
export const ASSET_PREFIX = '/account-lookup';
export const SUBMIT = 'Submit';
export const CANCEL = 'Cancel';
export const UNAUTHENTICATED_STATUS_CODES = ['1005', '1006', '1009'];
export const PET_STATUS_CODES = ['2020', '2021'];
export const OMNI_LOA2 = 'OMNI_LOA2';

//accessibility
export const ALT_TEXT = {
  prescriptionCard:
    'Front of the Prescription card with the ID outlined in red near the bottom of the card between issuer and your insurance name.',
  insuranceCard:
    'Front of the Insurance card with the ID outlined in red near the bottom of the card between issuer and your insurance name. '
};
